const initialState = {
    customers: [],
    holidays: [],

    // ✅ nieuw
    isLoadingCustomerProjects: false,
    customerProjectsError: null,
	isSavingWorkSession: false,
	workSessionSaveError: null
};

export default function (state = initialState, action) {

    switch (action.type) {

        case "FETCH_CUSTOMER_PROJECTS_FROM_MENDIX_REQUEST":
            return {
                ...state,
                isLoadingCustomerProjects: true,
                customerProjectsError: null
            };

        case "FETCH_CUSTOMER_PROJECTS_FROM_MENDIX_SUCCESS":
            return {
                ...state,
                customers: action.payload || [],
                isLoadingCustomerProjects: false,
                customerProjectsError: null
            };

        case "FETCH_CUSTOMER_PROJECTS_FROM_MENDIX_FAILURE":
            return {
                ...state,
                isLoadingCustomerProjects: false,
                customerProjectsError: action.payload || true
            };

        // ✅ backwards compatible (als er nog ergens oude dispatch zit)
        case "FETCH_CUSTOMER_PROJECTS_FROM_MENDIX":
            return {
                ...state,
                customers: action.payload || [],
                isLoadingCustomerProjects: false,
                customerProjectsError: null
            };

        case "FETCH_ALL_HOLIDAYS":
            return {
                ...state,
                holidays: action.payload || []
            };

        // Alleen nog uren lokaal bijwerken
        case "ADD_WORK_SESSION": {
            // ... jouw bestaande code ...
            return state;
        }
		case "ADD_WORK_SESSION_REQUEST":
			return {
				...state,
				isSavingWorkSession: true,
				workSessionSaveError: null
			};

		case "ADD_WORK_SESSION_SUCCESS":
			return {
				...state,
				isSavingWorkSession: false,
				workSessionSaveError: null
			};

		case "ADD_WORK_SESSION_FAILURE":
			return {
				...state,
				isSavingWorkSession: false,
				workSessionSaveError: action.payload || true
			};

        default:
            return state;
    }
}